module.exports = __webpack_public_path__ + "img/img7.419d4852.svg";